import React from 'react';
import ContentLoader from 'react-content-loader';

import { MaterialUICore } from '@iclinic/design-system';
import { ResponsiveCard } from '../..';

const { useMediaQuery, useTheme } = MaterialUICore;

const values = {
  backgroundColor: '#ECEFF1',
  foregroundColor: '#F8F9FA',
  speed: 1,
};

const CardAccountDataLoader = (): JSX.Element => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <ResponsiveCard variant="outlined">
      <ContentLoader
        speed={values.speed}
        width="100%"
        height={matches ? 218 : 310}
        backgroundColor={values.backgroundColor}
        foregroundColor={values.foregroundColor}
        uniqueKey="bank-account-loader"
      >
        <rect x="0" y="0" rx="2" ry="2" width="200" height="40" />
        <rect x="0" y="48" rx="2" ry="2" width="534" height="16" />
        <rect
          x="0"
          y="84"
          rx="2"
          ry="2"
          width={matches ? '396' : '100%'}
          height="58"
        />
        <rect
          x="0"
          y="164"
          rx="2"
          ry="2"
          width={matches ? '186' : '100%'}
          height="58"
        />
        <rect
          x={matches ? '210' : '0'}
          y={matches ? '480' : '244'}
          rx="2"
          ry="2"
          width={matches ? '186' : '100%'}
          height="58"
        />
        {matches && (
          <rect x="210" y="164" rx="2" ry="2" width="186" height="56" />
        )}
      </ContentLoader>
    </ResponsiveCard>
  );
};

export default CardAccountDataLoader;
